// extracted by mini-css-extract-plugin
export var bodySections = "_3u-8";
export var gray = "_3u-7";
export var green = "_3u-4";
export var iconContainer = "_3u-9";
export var iconWidgetContainer = "_3u-1";
export var phoneIcon = "_3u-2";
export var red = "_3u-5";
export var statusDot = "_3u-3";
export var widgetContainer = "_3u-0";
export var yellow = "_3u-6";